import React, { forwardRef, useEffect } from "react";

import SearchBox from './SearchBox.jsx'

const SearchBar = forwardRef((props, ref) => {

  return (
    <div className="ft_dealer-locator__results__search-bar" ref={ref}>
      <div className="ft_dealer-locator__container">
        <div className="ft_dealer-locator__results__search-bar__top">
          <SearchBox />
        </div>
      </div>
    </div>
  );

});

export default SearchBar;

